import { render, staticRenderFns } from "./RequestHistoryWidget.vue?vue&type=template&id=628adcd9&scoped=true"
import script from "./RequestHistoryWidget.vue?vue&type=script&lang=js"
export * from "./RequestHistoryWidget.vue?vue&type=script&lang=js"
import style0 from "./RequestHistoryWidget.vue?vue&type=style&index=0&id=628adcd9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628adcd9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('628adcd9')) {
      api.createRecord('628adcd9', component.options)
    } else {
      api.reload('628adcd9', component.options)
    }
    module.hot.accept("./RequestHistoryWidget.vue?vue&type=template&id=628adcd9&scoped=true", function () {
      api.rerender('628adcd9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/RequestHistoryWidget.vue"
export default component.exports